/* eslint-disable */
export default {
  cancel: 'Peruuta',
  reply: 'Vastaa',
  onMyWay: 'Olen tulossa',
  customMessage: 'Mukautettu viesti',
  callMeBackIn: 'Soita takaisin, kun on kulunut',
  willCallYouBackIn: 'Soitan takaisin, kun on kulunut',
  min: 'min',
  hours: 'tuntia',
  days: 'päivää',
} as const;

// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"reply"@#@ @source: @#@"Reply"@#@
// @key: @#@"onMyWay"@#@ @source: @#@"On my way"@#@
// @key: @#@"customMessage"@#@ @source: @#@"Custom Message"@#@
// @key: @#@"callMeBackIn"@#@ @source: @#@"Call me back in"@#@
// @key: @#@"willCallYouBackIn"@#@ @source: @#@"Will call you back in"@#@
// @key: @#@"min"@#@ @source: @#@"min"@#@
// @key: @#@"hours"@#@ @source: @#@"hours"@#@
// @key: @#@"days"@#@ @source: @#@"days"@#@
